/** Palette used to color data-table (schema) dependency dots; assigned in first-seen schema order. */
export const SCHEMA_COLORS: readonly string[] = [
    '#FF6A73',
    '#44AAC2',
    '#FCD068',
    '#39972B',
    '#6D7AAD',
    '#5D3DEF',
    '#4C1130',
    '#251B37',
    '#1473E6',
    '#515050',
] as const;
